function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { createVNode, createComponentVNode } from "inferno";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component } from 'inferno';
import EditableComponent from 'dmn-js-shared/lib/components/EditableComponent';
import { Cell, inject } from 'table-js/lib/components';

var EditableAnnotationCell = /*#__PURE__*/function (_Component) {
  _inherits(EditableAnnotationCell, _Component);

  var _super = _createSuper(EditableAnnotationCell);

  function EditableAnnotationCell(props, context) {
    var _this;

    _classCallCheck(this, EditableAnnotationCell);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "onElementsChanged", function () {
      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "setAnnotationValue", function (text) {
      var row = _this.props.row;

      _this.modeling.editAnnotation(row.businessObject, text);
    });

    inject(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EditableAnnotationCell, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var row = this.props.row;
      this.changeSupport.onElementsChanged(row.id, this.onElementsChanged);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var row = this.props.row;
      this.changeSupport.offElementsChanged(row.id, this.onElementsChanged);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          row = _this$props.row,
          rowIndex = _this$props.rowIndex;
      var _row$businessObject = row.businessObject,
          description = _row$businessObject.description,
          id = _row$businessObject.id;
      return createComponentVNode(2, Cell, {
        "className": "annotation",
        "onChange": this.setAnnotationValue,
        "coords": "".concat(rowIndex, ":annotation"),
        "value": description,
        "elementId": id,
        "data-row-id": row.id,
        children: createComponentVNode(2, AnnotationEditor, {
          "ctrlForNewline": true,
          "className": "annotation-editor",
          "onChange": this.setAnnotationValue,
          "value": description
        })
      });
    }
  }]);

  return EditableAnnotationCell;
}(Component);

export { EditableAnnotationCell as default };
EditableAnnotationCell.$inject = ['changeSupport', 'modeling'];

var AnnotationEditor = /*#__PURE__*/function (_EditableComponent) {
  _inherits(AnnotationEditor, _EditableComponent);

  var _super2 = _createSuper(AnnotationEditor);

  function AnnotationEditor() {
    _classCallCheck(this, AnnotationEditor);

    return _super2.apply(this, arguments);
  }

  _createClass(AnnotationEditor, [{
    key: "render",
    value: function render() {
      return createVNode(1, "div", this.getClassName(), this.getEditor(), 0);
    }
  }]);

  return AnnotationEditor;
}(EditableComponent);
//# sourceMappingURL=AnnotationCell.js.map